export default function unifyGroupVariants(product) {
  if (!product) {
    return [];
  }

  return product.variants;
}
